import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

type NotificationValue = {
  severity: NotificationSeverity;
  summary: string;
  detail: string;
};

enum NotificationSeverity {
  default = 'secondary',
  success = 'success',
  error = 'error',
  warn = 'warn',
  info = 'info',
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor() {}

  private _notificationSubject: BehaviorSubject<NotificationValue> =
    new BehaviorSubject<NotificationValue>({
      severity: NotificationSeverity.default,
      summary: '',
      detail: '',
    });

  public showNotification(): Observable<NotificationValue> {
    return this._notificationSubject.asObservable();
  }

  public showSuccessNotification(message: string) {
    this._notificationSubject.next({
      severity: NotificationSeverity.success,
      summary: 'Success',
      detail: message,
    });
  }

  public showErrorNotification(message: string) {
    this._notificationSubject.next({
      severity: NotificationSeverity.error,
      summary: 'Error',
      detail: message,
    });
  }

  public showWarnNotification(message: string) {
    this._notificationSubject.next({
      severity: NotificationSeverity.warn,
      summary: 'Warning',
      detail: message,
    });
  }

  public showInfoNotification(message: string) {
    this._notificationSubject.next({
      severity: NotificationSeverity.info,
      summary: 'Info',
      detail: message,
    });
  }
}
